module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dialogTitle":"Create division","eventsDivisionsActionsCreateSuccess":"%{divisionDay} kl. %{divisionStartsAt} was successfully added to the database"},"no":{"dialogTitle":"Opprett standplassliste","eventsDivisionsActionsCreateSuccess":"%{divisionDay} kl. %{divisionStartsAt} ble lagt til i databasen"}}')
  delete Component.options._Ctor
}
